module.exports = __webpack_public_path__ + "static/img/avatar.fc2fce5c.svg";